import { cn } from "@/lib/utils";
import { Check } from "lucide-react";

interface FormStepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  stepTitles: string[];
  className?: string;
}

const FormStepIndicator = ({
  currentStep,
  totalSteps,
  stepTitles,
  className,
}: FormStepIndicatorProps) => {
  return (
    <div className={cn("w-full", className)}>
      {/* Progress bar */}
      <div className="flex items-center justify-between mb-2">
        {Array.from({ length: totalSteps }, (_, i) => {
          const stepNumber = i + 1;
          const isCompleted = stepNumber < currentStep;
          const isActive = stepNumber === currentStep;
          const isUpcoming = stepNumber > currentStep;

          return (
            <div key={stepNumber} className="flex items-center flex-1">
              {/* Step circle */}
              <div
                className={cn(
                  "w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-all duration-300 shrink-0",
                  isCompleted && "bg-primary text-primary-foreground",
                  isActive && "bg-primary text-primary-foreground ring-4 ring-primary/20",
                  isUpcoming && "bg-muted text-muted-foreground"
                )}
              >
                {isCompleted ? (
                  <Check className="w-4 h-4" />
                ) : (
                  stepNumber
                )}
              </div>

              {/* Connector line (not after last step) */}
              {stepNumber < totalSteps && (
                <div className="flex-1 h-0.5 mx-2">
                  <div
                    className={cn(
                      "h-full transition-all duration-300",
                      isCompleted ? "bg-primary" : "bg-muted"
                    )}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Current step title */}
      <p className="text-sm font-medium text-center text-foreground">
        {stepTitles[currentStep - 1]}
      </p>
      <p className="text-xs text-muted-foreground text-center mt-0.5">
        Étape {currentStep} sur {totalSteps}
      </p>
    </div>
  );
};

export { FormStepIndicator };
